module.exports = __webpack_public_path__ + "img/circle_bot_icon.77444d73.png";